import {DropdownButton, Dropdown} from "react-bootstrap";
import {SortOption} from "./useResourcesFiltersAndSort";

export interface ResourcesSortDropdownProps {
  /** Current sort option label, displayed in the button title. */
  sortOption: string;
  /**
   * Called when the user picks a new option. Falls back to `"Newest"` if
   * react-bootstrap emits a null event key.
   */
  setSortOption: (val: SortOption) => void;
}

/**
 * Sort selector for resource / guide overview pages.
 *
 * Offers the four sort modes understood by {@link useResourcesFiltersAndSort}:
 * `"Newest"`, `"Oldest"`, `"A–Z"`, `"Z–A"`.
 */
export default function ResourcesSortDropdown({ sortOption, setSortOption }: ResourcesSortDropdownProps) {
  return (
    <DropdownButton
      variant="outline-secondary"
      title={`Sort: ${sortOption}`}
      size="sm"
      className="mb-0"
      onSelect={(val) => setSortOption((val as any) || "Newest")}
    >
      <Dropdown.Item eventKey="Newest">Newest</Dropdown.Item>
      <Dropdown.Item eventKey="Oldest">Oldest</Dropdown.Item>
      <Dropdown.Item eventKey="A–Z">A–Z</Dropdown.Item>
      <Dropdown.Item eventKey="Z–A">Z–A</Dropdown.Item>
    </DropdownButton>
  );
}
